// SPDX-License-Identifier: AGPL-3.0-or-later

import Accessibility from '@app/features/accessibility/state/Accessibility';

const DEFAULT_MAX_LENGTH = 200;
const URL_PATTERN = /https?:\/\/([^/\s]+)[^\s]*/g;
const synthesisSupported = window.speechSynthesis != null;

export function isSupported(): boolean {
	return synthesisSupported;
}

function stripUrlsToDomain(text: string): string {
	return text.replace(URL_PATTERN, (_match, domain) => domain);
}

function truncateAtWordBoundary(text: string, maxLength: number): string {
	if (text.length <= maxLength) {
		return text;
	}
	const truncated = text.slice(0, maxLength);
	const lastSpace = truncated.lastIndexOf(' ');
	if (lastSpace > maxLength * 0.5) {
		return truncated.slice(0, lastSpace);
	}
	return truncated;
}

function normaliseText(text: string): string {
	return text.replace(/\s+/g, ' ').trim();
}

export function createUtterance(text: string, maxLength: number = DEFAULT_MAX_LENGTH): SpeechSynthesisUtterance | null {
	if (!synthesisSupported) {
		return null;
	}
	let processed = stripUrlsToDomain(text);
	processed = normaliseText(processed);
	if (!processed) {
		return null;
	}
	processed = truncateAtWordBoundary(processed, maxLength);
	const utterance = new SpeechSynthesisUtterance(processed);
	utterance.rate = Accessibility.ttsRate;
	return utterance;
}

export function speak(utterance: SpeechSynthesisUtterance, voice: SpeechSynthesisVoice | null): void {
	if (!synthesisSupported) {
		return;
	}
	if (voice) {
		utterance.voice = voice;
	}
	window.speechSynthesis.speak(utterance);
}

export function cancel(): void {
	if (!synthesisSupported) {
		return;
	}
	window.speechSynthesis.cancel();
}

export function getVoices(): Array<SpeechSynthesisVoice> {
	if (!synthesisSupported) {
		return [];
	}
	return window.speechSynthesis.getVoices();
}
